import React from 'react';

import EditIcon from 'Assets/icons/edit.svg';
import TrashIcon from 'Assets/icons/trash.svg';

export default function GeneralRiskImpactCategoriesTableRow(props) {
    return (
        <tr>
            <td className="tw-align-top" onClick={props.onEdit}>
                {props.impactCategory.title}
            </td>
            <td dangerouslySetInnerHTML={{ __html: props.impactCategory.description }} onClick={props.onEdit} />
            <td>
                <div className="tw-flex tw-items-center tw-gap-x-3.5">
                    <button type="button" className="tw-flex tw-items-center tw-gap-x-1.5 tw-text-sm tw-font-semibold tw-text-blue" onClick={props.onEdit}>
                        <EditIcon className="tw-h-3" />
                        <div>{$t('Edit')}</div>
                    </button>
                    <button type="button" className="tw-flex tw-items-center tw-gap-x-1.5 tw-text-sm tw-font-semibold tw-text-red" onClick={props.onDelete}>
                        <TrashIcon className="tw-h-3" />
                        <div>{$t('Delete')}</div>
                    </button>
                </div>
            </td>
        </tr>
    );
}
